import withAemIntegration from "../../withAemIntegration";
import loadable from "../../utils/loadable";
import env from "@lexus.com/ui/dist/utilities/env";
import { useFeatureFlag } from "@lexus.com/ui/dist/_nextgen/packages/config";

const VisualizerStandard = loadable(() =>
  import("@lexus.com/ui/dist/components/Visualizer")
);
const VisualizerBespoke = loadable(() =>
  import("@lexus.com/ui/dist/modules/VisualizerBespoke")
);
const ModelPageVisualizerImpl = loadable(() =>
  import("@lexus.com/ui/dist/_nextgen/components/Visualizer/ModelPageVisualizer/index.impl")
);

const VisualizerEditConfig = {
  emptyLabel: "Visualizer",
  isEmpty: function (props) {
    return !props || !props.title || props.title.trim().length < 1;
  },
};

const transformData = (props) => ({
  component: "Visualizer",
  props: {
    ...props,
    mediaLocation: env('REACT_APP_BASE_IMAGE_LOCATION'),
    textColor: props.fontColor,
    tabVariant: props?.tabVariant,
    tabTheme: props?.tabTheme,
    disclaimerAlts: props.angleImageInfos,
    expandEnabled: props.expandEnabled,
    fullWidthImages: props.fullWidthImages,
    hasCategoryTabs: props.hasCategoryTabs,
    trims: props.visualizerTabs?.map((tabs) => ({
      id: tabs.id,
      name: tabs.label,
      disclaimerAlts: tabs.angleImageInfos,
      views: tabs.visualizerInnerTabs?.map((innerTabs) => ({
        id: innerTabs.id,
        slideIndicatorType: innerTabs.slideIndicatorType,
        slideNumberSeparator: innerTabs.slideNumberSeparator,
        name: innerTabs.label,
        assetPathStructure: innerTabs.assetPathStructure,
        videoAsset: innerTabs.videoAsset,
        imageProfiles: {
          mobile: innerTabs.mobileImageProfile,
          desktop: innerTabs.desktopImageProfile,
          overlayMobile: innerTabs.overlayMobileImageProfile,
          overlayDesktop: innerTabs.overlayDesktopImageProfile,
        },
        type: innerTabs.type,
        numAngles: innerTabs.numAngles,
        is360Variant: innerTabs.is360Variant,
        hasTeaserVideo: !!(innerTabs?.videoAsset?.ambientVideo?.mp4 || innerTabs?.videoAsset?.ambientVideo?.webm),
        disclaimerAlts: innerTabs.angleImageInfos?.map((angleImageInfo) => ({
          ...angleImageInfo,
          modes: angleImageInfo?.environmentModes
        })),
        startingModifierIndex: innerTabs.startingModifierIndex,
        startingSwatchIndex: innerTabs?.startingSwatchIndex || innerTabs?.startingIconIndex,
        modifiers: innerTabs?.modifiers?.map((modifier) => ({
          value: modifier.id,
          label: modifier.label,
          media: modifier.asset,
        })),
        swatches: (innerTabs?.swatches?.map((swatch) => ({
          id: swatch?.id,
          name: swatch?.label,
          media: swatch?.asset,
          disclaimerAlts: swatch?.angleImageInfos,
          productCodes: swatch?.productCodes,
          modes: swatch?.modes,
        })) || []).concat(innerTabs?.icons?.map((icon) => ({
          id: icon?.id,
          name: icon?.label,
          svg: icon?.asset,
          includedInToggle: icon?.includedInToggle,
          modes: icon?.modes,
          type: icon?.type
        })) || []),
      })),
      bespokeTrimFields:
        tabs.visualizerTabBespokeFields?.trimName &&
          tabs.visualizerTabBespokeFields?.basePrice
          ? tabs.visualizerTabBespokeFields
          : undefined,
      categories: tabs.visualizerBespokeInnerTabs?.map((innerTabs) => ({
        id: innerTabs.id,
        name: innerTabs.label,
        type: innerTabs.type,
        numAngles: innerTabs.numAngles,
        currencySymbol: innerTabs.currencySymbol,
        assetPathStructure: innerTabs.assetPathStructure,
        assetExtension: innerTabs.assetExtension,
        disclaimerAlts: innerTabs.angleImageInfos,
        modifiers: innerTabs?.modifiers?.map((modifier) => ({
          value: modifier.id,
          label: modifier.label,
          media: modifier.asset,
          price: modifier.price,
          disclaimer: modifier.disclaimerCode,
          efcCode: modifier.efcCode,
        })),
        swatches: innerTabs?.swatches?.map((swatch) => ({
          id: swatch?.id,
          name: swatch?.label,
          media: swatch?.asset,
          disclaimerAlts: swatch?.angleImageInfos,
          price: swatch?.price,
          disclaimer: swatch?.disclaimerCode,
          efcCode: swatch?.efcCode,
          toolTipText: swatch?.toolTipText,
          toolTipImage: swatch?.toolTipImage,
        })),
      })),
    })),
  },
});

const Visualizer = (props) => {
  const data = transformData(props);
  const isV2Visualizer = useFeatureFlag('isV2Visualizer') ?? props?.v2Visualizer;
  const isBespokeVisualizer = data.props.trims[0]?.bespokeTrimFields && data.props.trims[0]?.categories;

  return (
    <>
      {
        isBespokeVisualizer ? (
          <VisualizerBespoke {...data.props} />
        ) : (
          isV2Visualizer ? <ModelPageVisualizerImpl {...props} /> : <VisualizerStandard {...data.props} />
        )
      }
    </>
  );
};

export default withAemIntegration("lexus/components/visualizer")(
  Visualizer,
  VisualizerEditConfig
);
